import { useContext } from "react";
import { AuthContext, type AuthContextType } from "@/contexts/AuthContextInstance";

/**
 * Хук для доступа к контексту аутентификации.
 *
 * Возвращает объект с данными пользователя и методами login/logout.
 *
 * @returns Контекст аутентификации.
 * @throws Error Если хук используется вне AuthProvider.
 */
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
